import styled from 'styled-components'

export const Container = styled.div`
	margin: 0 auto;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
	grid-column: span 2;
	width: 100%;
	z-index: 1;
`
